import { Checkbox, Input, Th, Select, Button, Stack, Tr } from '@chakra-ui/react'
import {useFilters} from 'hooks/useFilters/useFilters'
import {useCallback, useRef} from 'react'
import {Scanner} from 'components/Scanner/Scanner'

const Options = ({ filter, users, devices }) => {
	switch (true) {
		case filter === 'user_id':
			return users.map(user =>
				<option key={user._id} value={`${user.name} ${user.last_name}`}>{`${user.name} ${user.last_name}`}</option>
			)
		case filter === 'device_number':
			return devices.map(device =>
				<option key={device} value={device}>{device}</option>
			)
		case filter === 'with_deleted':
			return <>
				<option value='withTrashed'>With deleted</option>
				<option value='onlyTrashed'>Only deleted</option>
			</>
		case filter === 'category_group':
			return <>
				<option value='חנות'>חנות</option>
				<option value='מחסן'>מחסן</option>
			</>
		default:
			return <>
				<option value='Yes'>Yes</option>
				<option value='No'>No</option>
			</>
	}
}



export const ItemsCountedFilters = (props) => {
	const {countingId, getItemsCounted, counting} = props
	const {handleInputChange, handleExactMatchChange, handleSelectChange, filters, users, devices} = useFilters(countingId, getItemsCounted)

	const handleInputChangeCallback = useCallback((type) => (event) => { handleInputChange(type, event.target.value, 'partialy')}, [handleInputChange])
	const handleExactMatchChangeCallback = useCallback((type) => (event) => handleExactMatchChange(type, event.target.checked), [handleExactMatchChange])
	const handleSelectChangeCallback = useCallback((type) => (event) => handleSelectChange(type, event.target.value), [handleSelectChange])
    const upcInputRef = useRef(null)



	const filtersConfig = [
		{type: 'upc', placeholder: 'UPC', isSelect: false },
		{type: 'mkt_1', placeholder: 'MKT', isSelect: false},
		{type: '', isSeparator: true},
		{type: 'row_name', placeholder: 'Row', isSelect: false},
		counting.settings?.customRowNames ? {type: 'custom_row_name', placeholder: 'Custom Name', isSelect: false} : null,
		{type: '', isSeparator: true},
		{type: 'category_name', placeholder: 'Category', isSelect: false},
		{type: 'category_group', placeholder: 'Category Group', isSelect: true},
		{type: '', isSeparator: true},
		{type: 'time_interval', placeholder: 'Interval', isSelect: false},
		{type: 'device_number', placeholder: 'Device', isSelect: true},
		{type: 'user_id', placeholder: 'Name', isSelect: true},
		{type: 'is_found', placeholder: 'Invalid', isSelect: true},
		{type: 'is_manual', placeholder: 'Manual', isSelect: true},
		{type: 'with_deleted', placeholder: 'Without Deleted', isSelect: true},
	].filter(i=>i)

	const handleScanSuccess = useCallback((qrCodeSuccess) => {
		if (upcInputRef.current) {
			upcInputRef.current.value = qrCodeSuccess
		}
		handleInputChange('upc', qrCodeSuccess, 'partialy')
	}, [handleInputChange])

	return (
		<>
			<Tr>
				<Th><Scanner setQrMessage={handleScanSuccess}/></Th>
			</Tr>
			<Tr>
			{filtersConfig.map((filter, index) => filter.isSeparator ? <Th key={index}></Th>:
				<Th key={index}>
					{filter.isSelect ? (
						<Select placeholder={filter.placeholder} onChange={handleSelectChangeCallback(filter.type)}>
							<Options filter={filter.type} users={users} devices={devices} />
						</Select>
					) : (
						<>
							<Input placeholder={filter.placeholder} 
								ref={filter.type === 'upc' ? upcInputRef : undefined}
								defaultValue={filters[filter.type]?.replace(/%/g, '') ?? ''}
								onBlur={handleInputChangeCallback(filter.type)} />
							<Checkbox onChange={handleExactMatchChangeCallback(filter.type)}></Checkbox>
						</>
					)}
				</Th>
			)}
			</Tr>
		</>
	)
}
